import React from "react"
import clsx from "clsx"
import LazyLoad from "react-lazyload"
import slugify from "slugify"
import { BLOCKS } from "@contentful/rich-text-types"

import { Asset, RichText } from "components"

const OPTIONS = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <p className="cap-subtitle text-mineralGray">{children}</p>
    ),
  },
}

function StatItem({ megaPresent, content, title, index }) {
  if (title && content)
    return (
      <li
        className={clsx(
          "px-10 py-12 sm:py-14 md:py-16 text-center space-y-4 ring-1 sm:px-fluidMargin md:px-16 ring-mineralGray",
          !megaPresent && [
            (index === 0 || index === 1) && "bg-white",
            (index === 2 || index === 3) && "bg-lightBlue",
            (index === 4 || index === 5) && "bg-white",
          ],
          megaPresent && [
            (index === 0 || index === 1) && "bg-lightBlue",
            (index === 2 || index === 3) && "bg-white",
            (index === 4 || index === 5) && "bg-lightBlue",
          ]
        )}
      >
        <p className="h2 text-darkNavy">{title}</p>
        <RichText content={content} options={OPTIONS} />
      </li>
    )
  else return null
}

function StatGrid({
  focusImage,
  focusText,
  focusVideo,
  heading,
  statItems,
  subheading,
}) {
  return (
    <section
      data-slice="StatGrid"
      id={heading && slugify(heading)}
      className={clsx(
        "wrapper default-grid lg:pt-30",
        subheading
          ? "pt-24 gap-y-10 md:gap-y-14"
          : "lg:pb-30 pt-16 gap-y-16 md:gap-y-24"
      )}
    >
      <div className="space-y-4 col-span-full md:col-span-10 md:col-start-2">
        {heading && (
          <h2
            className={clsx(
              "text-darkNavy",
              subheading ? "h4 text-darkNavy" : "h1 text-center"
            )}
          >
            {heading}
          </h2>
        )}
        {subheading && <RichText content={subheading} size="large" />}
      </div>

      <ul className="grid grid-cols-none -mx-6 border-b sm:-mx-fluidMargin md:mx-0 col-span-full md:grid-cols-2 border-mineralGray md:border-l md:border-r">
        {focusText && (
          <li className="ring-mineralGray ring-1 col-span-full default-grid gap-y-0">
            <div className="flex items-center px-6 py-8 md:py-14 col-span-full lg:col-span-5 sm:px-fluidMargin md:px-14">
              {focusText && <p className="h5 text-violet">{focusText}</p>}
            </div>
            <div className="flex items-center p-px col-span-full lg:col-span-7">
              <div className="w-full aspect-w-7 aspect-h-4">
                {focusImage && (
                  <Asset
                    asset={focusImage}
                    objectFit="cover"
                    objectPosition="center"
                    style={{ position: "absolute" }}
                  />
                )}
                {focusVideo && (
                  <LazyLoad
                    classNamePrefix="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
                    once
                  >
                    <Asset
                      className="absolute top-0 bottom-0 left-0 right-0 object-cover object-center w-full h-full"
                      asset={focusVideo}
                    />
                  </LazyLoad>
                )}
              </div>
            </div>
          </li>
        )}
        {statItems?.map((item, i) => {
          return (
            <StatItem
              megaPresent={focusText}
              {...item}
              index={i}
              key={`statItem--${i}`}
            />
          )
        })}
      </ul>
    </section>
  )
}

export default StatGrid
